import React from 'react';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function TermsOfService() {
  const navigate = useNavigate();
  return <div className="w-full min-h-screen bg-[#F6F8FB]" data-id="element-361">
      {/* Header */}
      <nav className="bg-white shadow-sm" data-id="element-362">
        <div className="max-w-4xl mx-auto px-6 py-4" data-id="element-363">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-[#0B1220] hover:text-[#3B82F6] transition-colors" data-id="element-364">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-365" />
            <span className="font-medium" data-id="element-366">Back to Home</span>
          </button>
        </div>
      </nav>
      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12" data-id="element-367">
        <div className="flex items-center gap-3 mb-6" data-id="element-368">
          <div className="w-12 h-12 bg-gradient-to-br from-[#3B82F6] to-[#10B981] rounded-lg flex items-center justify-center" data-id="element-369">
            <ShieldCheckIcon className="w-7 h-7 text-white" data-id="element-370" />
          </div>
          <h1 className="text-4xl font-bold text-[#0B1220]" data-id="element-371">
            Terms of Service
          </h1>
        </div>
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8" data-id="element-372">
          <div className="text-sm text-gray-500 mb-6" data-id="element-373">
            Last Updated: January 2025
          </div>
          <section data-id="element-374">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-375">
              1. Acceptance of Terms
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-376">
              By accessing or using G.S. HRC's services, you agree to be bound
              by these Terms of Service. If you do not agree to these terms, you
              may not access or use our services.
            </p>
          </section>
          <section data-id="element-377">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-378">
              2. Business-to-Business Services
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-379">
              Our services are exclusively provided to verified businesses. By
              using our services, you represent and warrant that:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-380">
              <li data-id="element-381">You are a registered business entity</li>
              <li data-id="element-382">You have the authority to enter into this agreement</li>
              <li data-id="element-383">
                You will use our products for legitimate business purposes only
              </li>
              <li data-id="element-384">You will comply with all applicable laws and regulations</li>
            </ul>
          </section>
          <section data-id="element-385">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-386">
              3. Verification Requirements
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-387">
              All customers must complete our business verification process
              before placing orders. We reserve the right to request additional
              documentation and to refuse service to any business that does not
              meet our verification standards.
            </p>
          </section>
          <section data-id="element-388">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-389">
              4. Product Information
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-390">
              We strive to provide accurate product information, but we do not
              warrant that product descriptions, pricing, or other content is
              error-free. We reserve the right to correct errors and update
              information without prior notice.
            </p>
          </section>
          <section data-id="element-391">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-392">
              5. Orders and Pricing
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-393">
              All orders are subject to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-394">
              <li data-id="element-395">Acceptance and confirmation by G.S. HRC</li>
              <li data-id="element-396">Product availability and minimum order quantities</li>
              <li data-id="element-397">Credit approval and payment terms</li>
              <li data-id="element-398">Compliance with export control and trade regulations</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-3" data-id="element-399">
              Prices are subject to change without notice. Orders are binding
              once confirmed by us.
            </p>
          </section>
          <section data-id="element-400">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-401">
              6. Payment Terms
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-402">
              Payment terms are established on a case-by-case basis. Late
              payments may incur interest charges and may result in suspension
              of services. All prices are exclusive of applicable taxes, duties,
              and shipping costs.
            </p>
          </section>
          <section data-id="element-403">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-404">
              7. Shipping and Delivery
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-405">
              Shipping terms, delivery times, and risk of loss are specified in
              individual orders. We are not responsible for delays caused by
              customs, carriers, or force majeure events.
            </p>
          </section>
          <section data-id="element-406">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-407">
              8. Returns and Warranties
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-408">
              Returns are subject to our return policy and may require
              manufacturer authorization. Products are covered by manufacturer
              warranties. We disclaim all other warranties, express or implied,
              including merchantability and fitness for a particular purpose.
            </p>
          </section>
          <section data-id="element-409">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-410">
              9. Limitation of Liability
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-411">
              To the maximum extent permitted by law, G.S. HRC shall not be
              liable for any indirect, incidental, special, or consequential
              damages arising from the use of our products or services. Our
              total liability shall not exceed the amount paid for the specific
              product or service giving rise to the claim.
            </p>
          </section>
          <section data-id="element-412">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-413">
              10. Compliance and Export Controls
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-414">
              Customers are responsible for compliance with all applicable
              export control laws and regulations. You agree not to export or
              re-export products in violation of any applicable laws.
            </p>
          </section>
          <section data-id="element-415">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-416">
              11. Intellectual Property
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-417">
              All content on our website, including text, graphics, logos, and
              images, is the property of G.S. HRC or our licensors and is
              protected by intellectual property laws.
            </p>
          </section>
          <section data-id="element-418">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-419">
              12. Termination
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-420">
              We reserve the right to terminate or suspend access to our
              services at any time, without prior notice, for any reason,
              including breach of these Terms of Service.
            </p>
          </section>
          <section data-id="element-421">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-422">
              13. Governing Law
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-423">
              These Terms of Service are governed by the laws of the United Arab
              Emirates. Any disputes shall be subject to the exclusive
              jurisdiction of the courts of the UAE.
            </p>
          </section>
          <section data-id="element-424">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-425">
              14. Changes to Terms
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-426">
              We reserve the right to modify these Terms of Service at any time.
              Continued use of our services after changes constitutes acceptance
              of the modified terms.
            </p>
          </section>
          <section data-id="element-427">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-428">
              15. Contact Information
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-429">
              For questions about these Terms of Service, please contact us at:
            </p>
            <div className="mt-4 p-4 bg-gray-50 rounded-lg" data-id="element-430">
              <p className="text-gray-700 font-medium" data-id="element-431">G.S. HRC</p>
              <p className="text-gray-700" data-id="element-432">Email: contact@grapeskinhrc.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>;
}